import {
	Backdrop,
	Box,
	CircularProgress,
	Grid,
	LinearProgress,
	Typography,
	useTheme,
} from '@mui/material'

import type { FC } from 'react'

interface LoadingBackdropProps {
	isOpen: boolean
}

export const Loading: FC = () => {
	return (
		<Box width={1} height={1} display={'flex'} justifyContent={'center'} alignItems={'center'}>
			<Typography variant="h4">Loading...</Typography>
		</Box>
	)
}

export const LoadingBackdrop: FC<LoadingBackdropProps> = ({ isOpen }) => {
	return (
		<Backdrop
			open={isOpen}
			role="loading-backdrop"
			sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
		>
			<CircularProgress color="inherit" />
		</Backdrop>
	)
}

export const LoadingBar: FC = () => {
	const theme = useTheme()

	return (
		<Grid position="absolute" zIndex={theme.zIndex.drawer + 1} top="0" width="stretch">
			<LinearProgress />
		</Grid>
	)
}
